import { render, staticRenderFns } from "./LeafNutrients.vue?vue&type=template&id=cbfd21fa"
import script from "./LeafNutrients.vue?vue&type=script&lang=js"
export * from "./LeafNutrients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports